var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUz(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M473.655,88.276H38.345C17.167,88.276,0,105.443,0,126.621v63.539h512v-63.539 C512,105.443,494.833,88.276,473.655,88.276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M0,385.379c0,21.177,17.167,38.345,38.345,38.345h435.31c21.177,0,38.345-17.167,38.345-38.345 V321.84H0V385.379z"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 204.1,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 103.79
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "0,200.092 0,204.102 512,204.102 512,200.092 512,190.159 0,190.159  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "0,311.908 0,321.841 512,321.841 512,311.908 512,307.898 0,307.898  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M113.491,172.071c-18.072,0-32.721-14.614-32.721-32.621c0-18.073,14.648-32.753,32.721-32.753 c0.07,0,0.138,0,0.206,0.001c1.064,0.014,1.437-1.399,0.499-1.902c-5.565-2.983-11.916-4.671-18.668-4.622 c-21.624,0.154-39.189,18.073-38.959,39.697c0.226,21.401,17.722,38.724,39.242,38.724c6.659,0,12.921-1.685,18.417-4.627 c0.935-0.501,0.557-1.914-0.503-1.899C113.645,172.071,113.568,172.071,113.491,172.071z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M139.113,163.05l-1.461,4.382l-4.619,0.035c-0.598,0.004-0.846,0.768-0.365,1.123l3.716,2.744 l-1.394,4.404c-0.18,0.57,0.469,1.042,0.956,0.694l3.758-2.686l3.758,2.686c0.487,0.348,1.135-0.124,0.956-0.694l-1.394-4.404 l3.715-2.744c0.481-0.355,0.233-1.119-0.365-1.123l-4.619-0.035l-1.461-4.382C140.105,162.483,139.303,162.483,139.113,163.05z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M171.656,163.05l-1.461,4.382l-4.619,0.035c-0.598,0.004-0.846,0.768-0.365,1.123l3.715,2.744 l-1.394,4.404c-0.18,0.57,0.469,1.042,0.956,0.694l3.758-2.686l3.758,2.686c0.487,0.348,1.135-0.124,0.956-0.694l-1.394-4.404 l3.715-2.744c0.481-0.355,0.233-1.119-0.365-1.123l-4.619-0.035l-1.461-4.382C172.647,162.483,171.844,162.483,171.656,163.05z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M204.198,163.05l-1.461,4.382l-4.619,0.035c-0.598,0.004-0.846,0.768-0.365,1.123l3.716,2.744 l-1.394,4.404c-0.18,0.57,0.469,1.042,0.956,0.694l3.758-2.686l3.758,2.686c0.487,0.348,1.135-0.124,0.956-0.694l-1.394-4.404 l3.715-2.744c0.481-0.355,0.233-1.119-0.365-1.123l-4.619-0.035l-1.461-4.382C205.19,162.483,204.387,162.483,204.198,163.05z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M236.74,163.05l-1.461,4.382l-4.619,0.035c-0.598,0.004-0.846,0.768-0.365,1.123l3.715,2.744 l-1.394,4.404c-0.18,0.57,0.469,1.042,0.956,0.694l3.758-2.686l3.758,2.686c0.487,0.348,1.135-0.124,0.956-0.694l-1.394-4.404 l3.715-2.744c0.481-0.355,0.233-1.119-0.365-1.123l-4.619-0.035l-1.461-4.382C237.732,162.483,236.929,162.483,236.74,163.05z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M269.283,163.05l-1.461,4.382l-4.619,0.035c-0.598,0.004-0.846,0.768-0.365,1.123l3.716,2.744 l-1.394,4.404c-0.18,0.57,0.469,1.042,0.956,0.694l3.758-2.686l3.758,2.686c0.487,0.348,1.135-0.124,0.956-0.694l-1.394-4.404 l3.716-2.744c0.481-0.355,0.233-1.119-0.365-1.123l-4.619-0.035l-1.461-4.382C270.274,162.483,269.472,162.483,269.283,163.05z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M171.656,132.678l-1.461,4.382l-4.619,0.035c-0.598,0.004-0.846,0.768-0.365,1.123l3.715,2.744 l-1.394,4.404c-0.18,0.57,0.469,1.042,0.956,0.694l3.758-2.686l3.758,2.686c0.487,0.348,1.135-0.124,0.956-0.694l-1.394-4.404 l3.715-2.744c0.481-0.355,0.233-1.119-0.365-1.123l-4.619-0.035l-1.461-4.382C172.647,132.109,171.844,132.109,171.656,132.678z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M204.198,132.678l-1.461,4.382l-4.619,0.035c-0.598,0.004-0.846,0.768-0.365,1.123l3.716,2.744 l-1.394,4.404c-0.18,0.57,0.469,1.042,0.956,0.694l3.758-2.686l3.758,2.686c0.487,0.348,1.135-0.124,0.956-0.694l-1.394-4.404 l3.715-2.744c0.481-0.355,0.233-1.119-0.365-1.123l-4.619-0.035l-1.461-4.382C205.19,132.109,204.387,132.109,204.198,132.678z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M236.74,132.678l-1.461,4.382l-4.619,0.035c-0.598,0.004-0.846,0.768-0.365,1.123l3.715,2.744 l-1.394,4.404c-0.18,0.57,0.469,1.042,0.956,0.694l3.758-2.686l3.758,2.686c0.487,0.348,1.135-0.124,0.956-0.694l-1.394-4.404 l3.715-2.744c0.481-0.355,0.233-1.119-0.365-1.123l-4.619-0.035l-1.461-4.382C237.732,132.109,236.929,132.109,236.74,132.678z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M269.283,132.678l-1.461,4.382l-4.619,0.035c-0.598,0.004-0.846,0.768-0.365,1.123l3.716,2.744 l-1.394,4.404c-0.18,0.57,0.469,1.042,0.956,0.694l3.758-2.686l3.758,2.686c0.487,0.348,1.135-0.124,0.956-0.694l-1.394-4.404 l3.716-2.744c0.481-0.355,0.233-1.119-0.365-1.123l-4.619-0.035l-1.461-4.382C270.274,132.109,269.472,132.109,269.283,132.678z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M204.198,163.05l-1.461,4.382l-4.619,0.035c-0.598,0.004-0.846,0.768-0.365,1.123l3.716,2.744 l-1.394,4.404c-0.18,0.57,0.469,1.042,0.956,0.694l3.758-2.686l3.758,2.686c0.487,0.348,1.135-0.124,0.956-0.694l-1.394-4.404 l3.715-2.744c0.481-0.355,0.233-1.119-0.365-1.123l-4.619-0.035l-1.461-4.382C205.19,162.483,204.387,162.483,204.198,163.05z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M204.198,102.304l-1.461,4.382l-4.619,0.035c-0.598,0.004-0.846,0.768-0.365,1.123l3.716,2.744 l-1.394,4.404c-0.18,0.57,0.469,1.042,0.956,0.694l3.758-2.686l3.758,2.686c0.487,0.348,1.135-0.124,0.956-0.694l-1.394-4.404 l3.715-2.744c0.481-0.355,0.233-1.119-0.365-1.123l-4.619-0.035l-1.461-4.382C205.19,101.737,204.387,101.737,204.198,102.304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M236.74,163.05l-1.461,4.382l-4.619,0.035c-0.598,0.004-0.846,0.768-0.365,1.123l3.715,2.744 l-1.394,4.404c-0.18,0.57,0.469,1.042,0.956,0.694l3.758-2.686l3.758,2.686c0.487,0.348,1.135-0.124,0.956-0.694l-1.394-4.404 l3.715-2.744c0.481-0.355,0.233-1.119-0.365-1.123l-4.619-0.035l-1.461-4.382C237.732,162.483,236.929,162.483,236.74,163.05z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M269.283,163.05l-1.461,4.382l-4.619,0.035c-0.598,0.004-0.846,0.768-0.365,1.123l3.716,2.744 l-1.394,4.404c-0.18,0.57,0.469,1.042,0.956,0.694l3.758-2.686l3.758,2.686c0.487,0.348,1.135-0.124,0.956-0.694l-1.394-4.404 l3.716-2.744c0.481-0.355,0.233-1.119-0.365-1.123l-4.619-0.035l-1.461-4.382C270.274,162.483,269.472,162.483,269.283,163.05z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M236.74,102.304l-1.461,4.382l-4.619,0.035c-0.598,0.004-0.846,0.768-0.365,1.123l3.715,2.744 l-1.394,4.404c-0.18,0.57,0.469,1.042,0.956,0.694L237.33,113l3.758,2.686c0.487,0.348,1.135-0.124,0.956-0.694l-1.394-4.404 l3.715-2.744c0.481-0.355,0.233-1.119-0.365-1.123l-4.619-0.035l-1.461-4.382C237.732,101.737,236.929,101.737,236.74,102.304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M269.283,102.304l-1.461,4.382l-4.619,0.035c-0.598,0.004-0.846,0.768-0.365,1.123l3.716,2.744 l-1.394,4.404c-0.18,0.57,0.469,1.042,0.956,0.694l3.758-2.686l3.758,2.686c0.487,0.348,1.135-0.124,0.956-0.694l-1.394-4.404 l3.716-2.744c0.481-0.355,0.233-1.119-0.365-1.123l-4.619-0.035l-1.461-4.382C270.274,101.737,269.472,101.737,269.283,102.304z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUz);
export default __webpack_public_path__ + "static/media/uz.17afbaf0c71d771bb353de117a9ce2b1.svg";
export { ForwardRef as ReactComponent };